import React, { forwardRef } from 'react';

import { styled } from '../theme';

const PageHeader = styled('header')<{ centered?: boolean }>(({ theme, centered }) => ({
    zIndex: theme.zIndex.pageHeader,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: 100,
    paddingLeft: 30,
    paddingRight: 30,
    flexShrink: 0,
    background: theme.color.white,
    color: theme.color.jetBlack,
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    justifyContent: centered ? 'center' : 'flex-start',
}));

export default forwardRef(({ children, ...restProps }, ref) => (
    <PageHeader id="page-header" {...restProps} ref={ref}>
        {children}
    </PageHeader>
));
